<template>
  <div class="left_aside">
    <div class="menu_title">
      <img class="menu_img" src="/static/img/menu_title_borde.png" alt />
    </div>

    <el-menu
      class="el-menu-vertical-demo"
      :default-active="activeIndex"
      :unique-opened="true"
      :default-openeds="[defaultOpenIndex]"
      background-color="#00000000"
      text-color="#fff"
      active-text-color="#1890FF"
    >
      <el-submenu index="1" v-show="showDataMunu">
        <template slot="title">
          <span>数据管理</span>
        </template>
        <el-menu-item v-for="(meun, index) in navList" :key="meun.id" v-show="meun.show === 'Y'" :index="'1-' + (index + 1)" @click="toList(meun, index)">{{ meun.name }}</el-menu-item>
      </el-submenu>
      <el-submenu index="2" v-show="showWAMunu">
        <template slot="title">
          <span>小程序</span>
        </template>
        <el-menu-item v-for="(meun, index) in navWaList" :key="meun.id" v-show="meun.show === 'Y'" :index="'2-' + (index + 1)" @click="toWAList(meun, index)">{{ meun.name }}</el-menu-item>
      </el-submenu>
    </el-menu>
  </div>
</template>

<script>
import * as Router from '@/utils/constant_router.js'

export default {
  // props: {
  //   activeIndex: {
  //     type: String
  //   }
  // },
  data() {
    return {
      activeIndex: '',
      defaultOpenIndex: '',
      menuIndex: 0,
      navList: JSON.parse(localStorage.getItem('navList')),
      navWaList: JSON.parse(localStorage.getItem('navWaList')),
      showDataMunu: localStorage.getItem('showDataMunu') == 'true',
      showWAMunu: localStorage.getItem('showWAMunu') == 'true'
    }
  },
  activated() {
    // 路由跳转设置初始值
    this.getMeunIndex()
  },
  // 离开当前界面时
  deactivated() {
    this.activeIndex = undefined // 设置为undefined重新渲染界面
  },
  created() {
    this.getMeunIndex()
    this.getNav()
  },
  methods: {
    getMeunIndex() {
      this.meunItem = JSON.parse(localStorage.getItem('meunItem'))
      this.activeIndex = this.meunItem.index
      this.defaultOpenIndex = this.activeIndex.split('-')[0]
    },
    getNav() {
      this.$api
        .getNav({
          token: localStorage.getItem('token')
        })
        .then(({ data }) => {
          this.navList = []
          this.navWaList = []
          
          // 按照固定顺序排列菜单
          const tempNavList = []
          const tempNavWaList = []
          
          data.Data.forEach((nav, index) => {
            if (Router.navList(nav.id)) {
              tempNavList.push(nav)
            }
            if (Router.navWaList(nav.id)) {
              tempNavWaList.push(nav)
            }
          })
          
          // 按照预定义顺序排序
          Router.DATA_MENU_ORDER.forEach(id => {
            const nav = tempNavList.find(n => n.id === id)
            if (nav) {
              this.navList.push(nav)
            }
          })
          
          Router.WA_MENU_ORDER.forEach(id => {
            const nav = tempNavWaList.find(n => n.id === id)
            if (nav) {
              this.navWaList.push(nav)
            }
          })
          
          let meunsChange = Router.meunsShowChange(JSON.parse(localStorage.getItem('meunList')), data.Data)
          localStorage.setItem('meunList', JSON.stringify(data.Data))

          this.showDataMunu = Router.meunNoOneShow(this.navList) == false
          this.showWAMunu = Router.meunNoOneShow(this.navWaList) == false
          localStorage.setItem('navList', JSON.stringify(this.navList))
          localStorage.setItem('navWaList', JSON.stringify(this.navWaList))
          localStorage.setItem('showDataMunu', this.showDataMunu)
          localStorage.setItem('showWAMunu', this.showWAMunu)

          if (meunsChange) {
            this.$message({
              message: '用户权限已修改',
              type: 'error',
              duration: 2000,
              onClose: function () {
                location.reload()
              }
            })
          }
          // console.log(this.meunItem.index)
          if (Router.meunNotChange(this.meunItem, data.Data)) {
            this.$emit('initData', this.meunItem)
            return
          }
          // if (index.substr(0, 2) == "2-") return;

          let meun = Router.getFirstMeun(this.navList)
          if (meun == null) {
            meun = Router.getFirstMeun(this.navWaList)
          }
          if (meun == null) {
            this.$message.error('用户无权限')
            localStorage.removeItem('token')
            this.$router.push('/')
          } else {
            meun.listPath = Router.getMeunRouter4MeunId(meun.id)
            localStorage.setItem('meunItem', JSON.stringify(meun))
            this.$router.push(meun.listPath)
          }
        })
        .catch(({ error }) => {})
    },
    toList(meun, index) {
      let path = Router.getMeunRouter4MeunId(meun.id)
      index = '1-' + (index + 1)
      this.push(meun, index, path)
    },
    toWAList(meun, index) {
      let path = Router.getMeunRouter4MeunId(meun.id)
      index = '2-' + (index + 1)
      this.push(meun, index, path)
    },
    push(meun, index, path) {
      meun.listPath = path
      meun.index = index
      localStorage.setItem('meunItem', JSON.stringify(meun))
      this.$router.push(meun.listPath)
    },
    // 前往操作日志
    toOpLog() {
      this.navList.forEach((meun, index) => {
        if (meun.id === 6) {
          index = '1-' + (index + 1)
          this.push(meun, index, '/data/op-log')
          return
        }
      })
    },
    removeKeepAliveCache() {
      if (this.$vnode && this.$vnode.data.keepAlive && this.$vnode.parent) {
        const tag = this.$vnode.tag
        let caches = this.$vnode.parent.componentInstance.cache
        let keys = this.$vnode.parent.componentInstance.keys
        for (let [key, cache] of Object.entries(caches)) {
          if (cache.tag === tag) {
            if (keys.length > 0 && keys.includes(key)) {
              keys.splice(keys.indexOf(key), 1)
            }
            delete caches[key]
          }
        }
      }
      this.$destroy()
    }
  },
  computed: {
    // 滚动区高度
    // (业务需求：手机屏幕高度减去头部标题和底部tabbar的高度，当然这2个高度也是可以动态获取的)
    scrollerHeight: function () {
      console.log(window.screen.availHeight)
      console.log(window.innerHeight)
      return window.innerHeight + 'px'
    }
  }
}
</script>

<style lang="less">
.left_aside {
  min-width: 260px;
  background-color: #191b23;
  overflow-y: auto;
  &::-webkit-scrollbar {
    // display: none;
  }
}
.menu_img {
  margin-top: 24px;
}
.menu_title {
  height: 77px;
  // display: table-cell; /*主要是这个属性*/
  // vertical-align: middle;
  text-align: center;
}
.el-menu {
  border-right: solid 0px #e6e6e6;
}
</style>


// WEBPACK FOOTER //
// src/components/layout/leftMeun.vue